export const ULTIMATE_AI_CATEGORY_IDS = [2, 10, 11, 23, 37, 59, 73, 86, 111, 129, 166, 171];
export const PERSONAL_BOOST_CATEGORY_IDS = [1, 33, 34, 35, 36, 108, 109, 110, 128, 163, 164, 165];

export type PackType = "ultimate_ai" | "personal_boost" | null;
